import type {Dungeon} from "@/dungeons/model/Dungeon.ts";
import type {DungeonFormOutput} from "./DungeonFormSchema.ts";

export function changedMapImages(data: DungeonFormOutput, original?: Dungeon): Array<{name: string; dimensionsChanged: boolean}> {
    if (!original) return [];
    const oldLevels = new Map(original.levels.map(level => [level.id, level]));
    return data.levels.flatMap(level => {
        const previous = oldLevels.get(level.id);
        const image = level.map.image;
        return previous && previous.map.image.id !== image.id
            ? [{name: level.name, dimensionsChanged: previous.map.image.width !== image.width
                || previous.map.image.height !== image.height}] : [];
    });
}
